import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { UserService } from 'src/app/services/shared/user.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { RoutingService } from 'src/app/services/routing.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import {EmailConfirmationResponse} from './EmailConfirmationResponse.enum';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';

@Component({
  selector: 'terra-email-confirm',
  templateUrl: './email-confirm.component.html',
  styleUrls: ['./email-confirm.component.scss']
})
export class EmailConfirmComponent extends OnDestroyMixin implements OnInit {
  paths = TerraUtils.consts.paths;

  isLoading = true;

  // Parameters
  token = '';
  email = '';

  confirmedSuccessful = false;
  confirmedError = false;
  errorMessage$ = new BehaviorSubject<string>('');

  loginPageUrl = this.routingService.loginUrlBySubdomain;
  referrerLogo$ = this.appSettingsService.subDomain === SubdomainEnum.GP ? this.userService.gp_referrerLogo$ : this.userService.lp_referrerLogo$;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private userService: UserService,
    public routingService: RoutingService,
    private snackbarService: SnackbarService,
    private appSettingsService:AppSettingsService
  ) {
    super();
  }

  ngOnInit() {
    this.titleService.setTitle('Email Confirmed');
    this.getQueryParameters();
    this.confirm();
  }

  getQueryParameters() {

    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.email = params.email;
      const tokenWithEscape = params['amp;token'];

      if (!this.token && tokenWithEscape) {
        this.token = tokenWithEscape;
      }
    });
  }


  confirm() {
    this.confirmedError = false;
    this.confirmedSuccessful = false;

    if (this.token && this.email) {
      this.isLoading = true;

      this.userService
        .confirmEmail(this.email, this.token)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
          untilComponentDestroyed(this)
        )
        .subscribe(
          response => {
            this.confirmedSuccessful = true;
            this.snackbarService.showGeneralMessage('Your email is now confirmed', 10);

            setTimeout(() => {
              this.router.navigate([this.routingService.defaultLoggedInPageBySubdomain], {
                queryParams: {isRegistered: "True"}
              });
            }, 1000);

          },
          error => {
            const errorCode = error.error?.message;
            if (errorCode == EmailConfirmationResponse.AccountDeleted) {
              this.errorMessage$.next('This account has been deleted, please sign up again');
            } else {
              this.errorMessage$.next('Something went wrong, please try again');
            }
            this.confirmedError = true;
            this.isLoading = false;
          }
        );
    } else {
      this.confirmedError = true;
      this.isLoading = false;
    }
  }
}
